import styled, { css } from 'styled-components';
import { colors } from '../../../utils/colors';

export const ContainerKanban = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding: 10px 20px;
  overflow-y: auto;
`;

export const BoxKanban = styled.div`
  max-width: 380px !important;
  min-width: 200px;
  margin: 5px;
`;

export const TextKanban = styled.div<{
  primary?: boolean;
  secundary?: boolean;
  prefixo?: boolean;
  prefixoSecundary?: boolean;
  conteudoPrefixo?: boolean;
  contSecundary?: boolean;
  icon?: boolean;
}>`
  ${(props) =>
    props.primary &&
    css`
      color: ${colors.verde};
      font-size: 14px;
      font-weight: 700;
      text-transform: uppercase;
      margin-bottom: 20px;
    `};

  ${(props) =>
    props.secundary &&
    css`
      display: flex;
      flex-direction: row;
      align-items: flex-end;
    `};

  ${(props) =>
    props.prefixo &&
    css`
      color: ${colors.verde};
      font-weight: 700;
      margin-right: 5px;
      font-size: 12px;
      width: 60px;
      text-transform: uppercase;
    `};

  ${(props) =>
    props.conteudoPrefixo &&
    css`
      font-weight: 700;
      font-size: 14px;
      color: ${colors.verde10};
      width: calc(100% - 60px);
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    `};

  ${(props) =>
    props.conteudoPrefixo &&
    props.contSecundary &&
    css`
      color: ${colors.preto};
    `};

  ${(props) =>
    props.prefixoSecundary &&
    css`
      margin-right: 10px;
    `};
  ${(props) =>
    props.icon &&
    css`
      font-size: 14px;
      text-transform: lowercase;
      display: flex;
      align-items: center;
    `};
`;

export const ColumnKanban = styled.div`
  background: rgb(240, 240, 240);
  min-height: 300px;
  max-width: 200px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  border-radius: 8px;
`;

export const CardKanban = styled.div<{ borderStatusgreen?: boolean }>`
  background: ${colors.branco};
  border-radius: 7px;
  padding: 10px;
  margin-top: 15px;
  margin-bottom: 15px;

  ${(props) =>
    props.borderStatusgreen &&
    css`
      border-bottom: 6px solid ${colors.verde10};
    `};
`;
